// Matches publishers.py's CLASS_ORDER - keep in sync if that ever changes.
export const CLASS_ORDER = ['250', '350', '500', '750', '1400', '1WD', '2WD', 'Unknown']

// NIGAN_MQTT's MqttPublisher.vb::GetClassDisplayName() emits differently
// formatted className strings for the same classes ("250 Class", "Sidecar",
// "Trike", "Unclassified") instead of this repo's own publishers.py raw
// codes - without normalizing first, every NIGAN-fed class missed
// CLASS_ORDER entirely and silently fell back to alphabetical sort.
const DISPLAY_ALIASES = { Sidecar: '1WD', Trike: '2WD', Unclassified: 'Unknown' }

function classKey(className) {
  if (DISPLAY_ALIASES[className]) return DISPLAY_ALIASES[className]
  const stripped = className.replace(/ Class$/, '')
  return CLASS_ORDER.includes(stripped) ? stripped : className
}

export function sortClasses(classNames) {
  return [...classNames].sort((a, b) => {
    const ai = CLASS_ORDER.indexOf(classKey(a))
    const bi = CLASS_ORDER.indexOf(classKey(b))
    if (ai === -1 && bi === -1) return a.localeCompare(b)
    if (ai === -1) return 1
    if (bi === -1) return -1
    return ai - bi
  })
}
